// config.js
const config = {
    // apiUrl: 'http://localhost:3001',
    // apiUrl: 'http://172.20.10.2:3001',
    apiUrl: 'https://n-n-cargo.asia:3001',
    
    nameCargo: 'N.N.CARGO'

  };
  
  
export default config;
